import { SITE_URL, toCanonicalUrl, toTitleCase } from "../../Components/Common/Seo/seoUtils.js";

export const AUTHOR_JOB_TITLE = "Brand Strategy Contributor";

export const AUTHOR_PROFILES = [
  {
    name: "Anima Agrawal",
    slug: "anima-agrawal",
    aliases: ["anima agrawal"],
  },
  {
    name: "Bhaskar",
    slug: "bhaskar",
    aliases: ["bhaskar"],
  },
  {
    name: "Bhaskar N",
    slug: "bhaskar-n",
    aliases: ["bhaskar n"],
  },
  {
    name: "Binoy Sundhar Parakat",
    slug: "binoy-sundhar-parakat",
    aliases: ["binoy sundhar parakat", "binoy s parakat"],
  },
  {
    name: "Kirty Sharma",
    slug: "kirty-sharma",
    aliases: ["kirty sharma", "kirti sharma"],
  },
  {
    name: "Preetha R",
    slug: "preetha",
    aliases: ["preetha", "preetha r"],
  },
  {
    name: "Priyank Vyas",
    slug: "priyank-vyas",
    aliases: ["priyank vyas"],
  },
  {
    name: "Sheetal Reddy",
    slug: "sheetal-reddy",
    aliases: ["sheetal", "sheetal reddy"],
  },
  {
    name: "Srinivas B",
    slug: "srinivas-b",
    aliases: ["srinivas", "srinivas b"],
  },
];

export function slugifyAuthorName(name = "") {
  return String(name || "")
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[’']/g, "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function getArticleAuthorName(article = {}) {
  const source = article || {};
  return String(source.created_by || source.author || source.createdBy || "").trim();
}

export function getAuthorProfileBySlug(slug = "") {
  const cleanSlug = slugifyAuthorName(slug);
  const profile = AUTHOR_PROFILES.find((author) => (
    author.slug === cleanSlug || author.aliases?.some((alias) => slugifyAuthorName(alias) === cleanSlug)
  ));

  return profile || (cleanSlug ? {
    name: toTitleCase(cleanSlug),
    slug: cleanSlug,
    aliases: [cleanSlug.replace(/-/g, " ")],
  } : null);
}

export function getAuthorProfileByName(name = "") {
  const cleanSlug = slugifyAuthorName(name);

  if (!cleanSlug) {
    return null;
  }

  return AUTHOR_PROFILES.find((author) => (
    author.slug === cleanSlug || author.aliases?.some((alias) => slugifyAuthorName(alias) === cleanSlug)
  )) || getAuthorProfileBySlug(cleanSlug);
}

export function buildAuthorPath(author = "") {
  const profile = typeof author === "object" && author?.slug
    ? author
    : getAuthorProfileByName(author);

  return profile?.slug ? `/author/${profile.slug}` : "";
}

export function getAuthorBio(author = "") {
  const profile = typeof author === "object" ? author : getAuthorProfileByName(author);
  const name = profile?.name || String(author || "").trim() || "This author";

  return `${name} is a brand strategy contributor at Brew Your Brand, writing about brand clarity, positioning, customer experience, and practical brand-building for founders, marketers, and MSME teams.`;
}

export function buildAuthorPersonSchema(author = "", articles = []) {
  const profile = typeof author === "object" ? author : getAuthorProfileByName(author);

  if (!profile) {
    return null;
  }

  const authorPath = buildAuthorPath(profile);
  const canonicalUrl = toCanonicalUrl(authorPath);

  return {
    "@context": "https://schema.org",
    "@type": "Person",
    "@id": `${canonicalUrl}#person`,
    name: profile.name,
    jobTitle: AUTHOR_JOB_TITLE,
    description: getAuthorBio(profile),
    url: canonicalUrl,
    worksFor: {
      "@type": "Organization",
      "@id": `${SITE_URL}/#organization`,
      name: "Brew Your Brand",
    },
    mainEntityOfPage: {
      "@type": "ProfilePage",
      "@id": canonicalUrl,
    },
    subjectOf: articles.map((article) => ({
      "@type": "BlogPosting",
      headline: article.title,
      url: toCanonicalUrl(article.url),
    })),
  };
}